// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingPriceGuestResponse

export type WidgetBookingPriceGuestApiResponse = {
	name: string;
	quantity: number;
	unitPrice: number;
	total: number;
};

export type WidgetBookingPriceGuest = {
	name: string;
	quantity: number;
	unitPrice: number;
	total: number;
};

export function hydrateWidgetBookingPriceGuest(data: WidgetBookingPriceGuestApiResponse): WidgetBookingPriceGuest {
	return { ...data };
}